import React, { memo, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { iconsPath, imagePath } from '../../utils/imagePath';
import useClickOutside from '../UseClickOutside';

export const RightIcon = React.memo(({ open, onClick, className }) => {
  return (
    <span
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      className={`ml-2 ${className}`}
    >
      <img
        src={iconsPath?.rightIcon}
        className={`transform transition-transform ${
          open ? 'rotate-90' : 'rotate-0'
        }`}
        alt="Right Icon"
      />
    </span>
  );
});

export const CloseIcon = React.memo(({ closeModal, className }) => {
  return (
    <>
      {closeModal && (
        <button
          onClick={closeModal}
          className={`hover:scale-110 hover:transition  top-3 right-3 h-[30px] w-[30px] rounded-full bg-[#31333A] p-[2px] text-white text-[20px] flex justify-center items-center ${className}`}
        >
          <img src={iconsPath.closeIcon} alt="close Icon" />
        </button>
      )}
    </>
  );
});

export const Brodcrumb = React.memo(({ data }) => {
  const navigate = useNavigate();
  return (
    <div className="">
      <div className="hidden sm:block ">
        {Object.keys(data)?.length > 0 && (
          <p
            className={`flex gap-2 text-[14px] text-[#D9D9D9] ${
              data?.mt ? data?.mt : ''
            } `}
          >
            {data?.item?.map((v, i) => (
              <span
                className="cursor-pointer  flex gap-2 items-center "
                key={i}
                onClick={() => navigate(v?.path)}
              >
                {/* {v?.name} <FaChevronRight size={16} className="font-light" /> */}
                {v?.name} <img src={iconsPath?.rightIcon} alt="Right Icon" />
              </span>
            ))}
            <span className="font-light"> {data.name}</span>
          </p>
        )}
      </div>
      <div>
        <BackButton />
      </div>
    </div>
  );
});

export const BackButton = React.memo(
  ({ className = 'flex sm:hidden', icon }) => {
    const navigate = useNavigate();
    return (
      <div
        className={`${className} gap-2 justify-start items-center cursor-pointer`}
        onClick={() => navigate(-1)}
      >
        {icon ? icon : <img src={iconsPath?.leftIcon} alt="Left Icon" />}
        Back
      </div>
    );
  }
);

export const SidebarSubmenu = React.memo(
  ({ subItem, onNavigate, isPathActive }) => {
    const [isOpen, setIsOpen] = useState(false);

    const isActive = isPathActive(subItem.path);

    return (
      <li>
        {subItem.path ? (
          // Item with direct link (no nested submenu)
          <Link
            to={subItem.path}
            onClick={onNavigate}
            className={`flex justify-start gap-2 items-center p-2 hover:bg-[#31333A] cursor-pointer rounded
            ${isActive ? 'bg-[#31333A] text-white' : ''}`}
          >
            {subItem.submenu?.length > 0 && (
              <img
                src={iconsPath.downIcon}
                alt="down icon"
                className={`transition-transform duration-300 ${
                  isOpen ? 'rotate-0' : '-rotate-90'
                }`}
              />
            )}
            <span>{subItem.name}</span>
          </Link>
        ) : (
          // Item with nested submenu (no direct link)
          <div
            className="flex justify-start gap-2 items-center p-2 hover:bg-[#31333A] cursor-pointer rounded"
            onClick={() => setIsOpen(!isOpen)}
          >
            {subItem.submenu?.length > 0 && (
              <img
                src={iconsPath.downIcon}
                alt="down icon"
                className={`transition-transform duration-300 ${
                  isOpen ? 'rotate-0' : '-rotate-90'
                }`}
              />
            )}
            <span>{subItem.name}</span>
          </div>
        )}

        {/* Nested Submenu */}
        {isOpen && subItem.submenu?.length > 0 && (
          <ul className="ml-4 mt-1 pl-4 flex flex-col gap-1">
            {subItem.submenu.map((nestedItem, nestedIndex) => {
              const nestedActive = isPathActive(nestedItem.path);

              return (
                <li key={nestedIndex}>
                  <Link
                    to={nestedItem.path}
                    onClick={onNavigate}
                    className={`block p-2 hover:bg-[#31333A] rounded cursor-pointer
                    ${nestedActive ? 'bg-[#31333A] text-white' : ''}`}
                  >
                    {nestedItem.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </li>
    );
  }
);

export const SidebarMenu = memo(({ arr, onClose }) => {
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [version, setVersion] = useState('1.0');

  const versionData = [
    { version: '1.0' },
    { version: '1.1' },
    { version: '1.2' },
    { version: '1.3' },
    { version: '1.4' },
  ];

  const [openMenus, setOpenMenus] = useState(() => {
    const state = {};
    arr.forEach((_, index) => {
      state[index] = false;
    });
    return state;
  });

  const toggleMenu = (index) => {
    setOpenMenus((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  /* Close version dropdown on outside click */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  /* Handle link click - close drawer on mobile */
  const handleNavigate = () => {
    if (onClose) onClose(false);
  };

  // Check if path is active
  const isPathActive = (itemPath) => {
    if (!itemPath) return false;
    return location.pathname === itemPath;
  };

  return (
    <>
      {/* VERSION SELECTOR */}
      {/* <div className="p-5 lg:p-0">
        <div
          ref={ref}
          className="relative w-full border-[#656565] border-2 p-3 rounded-[10px] mt-10 lg:mt-0"
          onClick={() => setOpen(!open)}
        >
          <div className="flex justify-between items-center cursor-pointer">
            <div className="flex gap-1 items-center">
              <span className="text-[12px]">Spatial Grid</span>
              <span className="text-[12px] font-light">Version {version}</span>
            </div>

            <img
              src={iconsPath.downIcon}
              alt="down"
              className={`transition-transform duration-300 ${
                open ? '-rotate-90' : 'rotate-0'
              }`}
            />
          </div>

          {open && (
            <div className="absolute z-20 top-[150%] left-0 w-full bg-[#515151] rounded-[10px]">
              {versionData.map((v, i) => (
                <div
                  key={i}
                  className="p-2 text-[12px] cursor-pointer hover:bg-black"
                  onClick={() => {
                    setVersion(v.version);
                    setOpen(false);
                  }}
                >
                  Version {v.version}
                </div>
              ))}
            </div>
          )}
        </div>
      </div> */}

      {/* SIDEBAR MENU */}
      <div className="w-full lg:w-60 xl:w-60 text-white  py-4 overflow-y-auto scrollbar">
        <ul className="space-y-2">
          {arr.map((item, index) => {
            const isActive = isPathActive(item.path);

            return (
              <li key={index}>
                {/* MAIN ITEM */}
                <div
                  className={`flex gap-3 items-center p-2 rounded cursor-pointer
                  hover:bg-[#31333A]
                  ${isActive ? 'bg-[#31333A]' : ''}`}
                  onClick={() => {
                    if (item.submenu?.length) {
                      toggleMenu(index);
                    }
                  }}
                >
                  {item.submenu?.length > 0 && (
                    <img
                      src={iconsPath.downIcon}
                      alt="toggle"
                      className={`transition-transform duration-300 ${
                        openMenus[index] ? 'rotate-0' : '-rotate-90'
                      }`}
                    />
                  )}

                  {item.path ? (
                    <Link
                      to={item.path}
                      onClick={handleNavigate}
                      className="font-semibold text-[12px] lg:text-[16px]"
                    >
                      {item.name}
                    </Link>
                  ) : (
                    <span className="semifont-bold text-[12px] lg:text-[16px]">
                      {item.name}
                    </span>
                  )}
                </div>

                {/* SUBMENU */}
                {openMenus[index] && item.submenu?.length > 0 && (
                  <ul className="ml-4 mt-2 space-y-1 pl-4">
                    {item.submenu.map((subItem, subIndex) => (
                      <SidebarSubmenu
                        key={subIndex}
                        subItem={subItem}
                        onNavigate={handleNavigate}
                        isPathActive={isPathActive}
                      />
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
});

export const DocumentationCard = React.memo(
  ({ title, desc, index, videoSrc, posterSrc }) => {
    const isEven = index % 2 === 0;

    return (
      <div
        className={`flex flex-col gap-8 w-full items-start
          lg:flex-row lg:gap-8
          ${!isEven ? 'lg:flex-row-reverse' : ''}
        `}
      >
        {/* TEXT SECTION */}
        <div className="flex flex-col gap-4 w-full lg:w-[44%]">
          <h3 className="text-3xl font-bold text-white">{title}</h3>

          <p className="text-lg font-medium text-[#717173] leading-relaxed">
            {desc}
          </p>
        </div>

        {/* VIDEO SECTION */}
        <div className="w-full lg:w-[80%] ">
          <div className="w-full h-full rounded-[14px] overflow-hidden">
            <video
              className="w-full h-full object-cover"
              autoPlay
              loop
              muted
              playsInline
              poster={posterSrc}
            >
              <source src={videoSrc} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    );
  }
);

export const ToolsCard = React.memo(
  ({ img, title, desc, hoverEffect = true }) => {
    return (
      <div className="w-full rounded-xl overflow-hidden group">
        {/* Image Wrapper */}
        <div className="relative w-full flex justify-center ">
          <img
            src={img}
            alt="tool-image"
            className={`
              w-full
              sm:w-full
              md:w-full
              lg:w-full
              object-contain
              transition-transform
              duration-500
              ease-[cubic-bezier(0.23,1,0.32,1)]
              ${hoverEffect ? 'group-hover:scale-[1.05]' : ''}
            `}
          />

          {/* Text Overlay (same styles, only positioning) */}
          <div className="absolute bottom-4 md:bottom-8 left-0 w-full flex flex-col items-center text-center gap-2 px-2">
            <h3 className="text-white font-medium text-sm sm:text-base md:text-lg lg:text-xl">
              {title}
            </h3>

            <p className="text-[#757678] text-sm sm:text-[15px] md:text-base lg:text-lg max-w-xl">
              {desc}
            </p>
          </div>
        </div>
      </div>
    );
  }
);

export const SuperChargeCard = React.memo(
  ({ img, title, desc, hoverEffect = true }) => {
    return (
      <div
        className="
          w-full
          bg-[#1A1C20]
          rounded-xl
          p-5 sm:p-6 lg:p-8
          flex flex-col
          items-center
          gap-4
          group
          overflow-hidden
        "
      >
        {/* Fixed Image Area */}
        <div
          className="
            w-full
            h-[180px]
            sm:h-[220px]
            md:h-[260px]
            lg:h-[300px]
            xl:h-[340px]
            flex
            items-center
            justify-center
          "
        >
          <img
            src={img}
            alt="tool-image"
            className={`
              max-w-full
              max-h-full
              object-contain
              transition-transform duration-500
              ease-[cubic-bezier(0.23,1,0.32,1)]
              ${hoverEffect ? 'group-hover:scale-[1.05]' : ''}
            `}
          />
        </div>

        {/* Text Content */}
        <div className="flex flex-col items-center text-center gap-2">
          <h3 className="text-white font-medium text-sm sm:text-base md:text-lg lg:text-xl">
            {title}
          </h3>

          <p className="text-[#757678] text-sm sm:text-[15px] md:text-base font-normal lg:text-lg max-w-xl">
            {desc}
          </p>
        </div>
      </div>
    );
  }
);

export const ModalDefaultComponent = React.memo(({ children, closeModal }) => {
  const modalRef = useRef(null);
  useClickOutside(modalRef, () => {
    closeModal();
  });
  return (
    <div
      ref={modalRef}
      className="flex justify-center items-center border border-[#444447] min-w-screen rounded-[10px] min-w-[500px] py-6 px-8 bg-[#1E1F22] overflow-hidden "
    >
      <div className="   rounded-lg  min-w-full md:min-w-[350px] max-w-[350px] justify-center items-center mr-auto ml-auto flex flex-col gap-2 min-h-[140px] h-auto w-full py-2">
        {children}
      </div>
    </div>
  );
});

export const TodaySpatial = React.memo(({ onButtonClick }) => {
  return (
    <div className="   mb-10 flex flex-col items-center gap-8 md:gap-12">
      <div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-12">
        {/* Logo Section */}
        <div className="flex-shrink-0">
          <img
            src={imagePath?.logo_small}
            alt="Spatial Grid Logo"
            className="w-20 md:w-32 object-contain"
          />
        </div>

        {/* Text Section */}
        <div className="text-center md:text-left max-w-4xl">
          <h5 className="text-[#98989A] text-lg md:text-xl font-semibold mb-3 md:mb-4">
            Today, Spatial Grid Leads the Way in Spatial Computing and
            Intelligent XR Solutions
          </h5>
          <p className="text-[#98989A] text-[18px] md:text-sm leading-relaxed">
            Combining the power of design, engineering, and AI-driven strategy
            to create transformative spatial experiences for the enterprise. We
            invite you to join us at the forefront of innovation — where
            physical and digital worlds converge. Discover how Spatial Grid can
            help your organization unlock immersive intelligence, redefine
            interaction, and bring visionary spatial experiences to life.
          </p>
        </div>
      </div>

      {/* Call to Action Banner */}
      <div className="bg-[#242424] bg-opacity-80 border-2 border-[#262626] rounded-md w-full max-w-[1200px] mx-auto p-4 md:py-0 md:h-[70px]">
        <div className="flex flex-col md:flex-row items-center justify-between h-full gap-4 md:gap-6 px-5 ">
          {/* Welcome Text */}
          <p className="text-sm sm:text-xs text-[#98989A] text-center md:text-left">
            Welcome to Spatial Grid
          </p>

          {/* Center Description */}
          <div className="bg-[#262626] px-4 sm:px-8 md:px-12 py-[10px] rounded-md w-full md:w-auto text-center md:text-left">
            <p className="text-sm sm:text-xs text-white">
              Where Spatial Intelligence Meets Deep Expertise to Power the
              Future of Immersive Enterprise Innovation.
            </p>
          </div>

          {/* Button */}
          <button
            onClick={onButtonClick}
            className="bg-[#EE2B2A] py-3 px-24 sm:py-3.5 sm:px-8 text-sm sm:text-xs md:text-[14px] text-white rounded-[10px] whitespace-nowrap"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
});

export const CTABanner = ({
  welcomeText,
  description,
  buttonText,
  navigateTo,
  onButtonClick,
}) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (navigateTo) {
      navigate(navigateTo);
    }
  };

  return (
    <div className="w-full flex justify-center px-4">
      <div
        className="bg-[#1A1C20] border z-[9] border-[#6A6A6A] rounded-[10px]
        w-full py-6 md:py-8 px-4 sm:px-6 md:px-10"
      >
        <div
          className="max-w-[1700px] w-full mx-auto 
          flex flex-col md:flex-row items-center 
          justify-between gap-8 md:gap-12"
        >
          {/* LEFT TEXT */}
          <div className="flex flex-col text-center md:text-left gap-3 w-full">
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-[#DADADA] font-jakarta">
              {welcomeText}
            </h2>
            <p
              className="text-[14px] leading-[20px] md:text-[16px] md:leading-[24px] lg:text-[18px] lg:leading-[26px] text-[#A3A3A3] max-w-full md:max-w-[810px] font-jakarta"
            >
              {description}
            </p>
          </div>

          {/* DIVIDER */}
          <div className="hidden md:block w-px h-20 bg-[#6A6A6A]" />

          {/* RIGHT BUTTON */}
          <button
            onClick={handleButtonClick}
            className="bg-[#EE2B2A] text-white rounded-lg text-sm sm:text-base py-3 px-8 sm:py-3.5 sm:px-12 w-full md:w-auto text-center whitespace-nowrap font-bold"
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};



export const ZigZagSection = ({
  number,
  title,
  description,
  subTitle,
  listItems = [],
  bottomText,
  image,
  reverse = false,
}) => {
  return (
    <div className="relative w-screen overflow-hidden mb-12 md:mb-16 lg:mb-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-8 md:gap-3">
        {/* TEXT */}
        <div
          className={`space-y-4 px-4 md:px-8 lg:px-12 xl:px-24 max-w-[980px] ${
            reverse ? 'lg:order-2' : 'lg:order-1'
          }`}
        >
          <div className="flex gap-2">
            <span className="text-white font-bold text-xl lg:text-2xl">
              {number}
            </span>
            <h3 className="text-xl lg:text-2xl font-bold text-white">
              {title}
            </h3>
          </div>

          <p className="text-[#D1D1D1]">{description}</p>

          {subTitle && (
            <h4 className="text-[#D1D1D1] font-semibold">{subTitle}</h4>
          )}

          {listItems.length > 0 && (
            <ul className="list-disc pl-5 space-y-2 text-[#D1D1D1]">
              {listItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}

          {bottomText && <p className="text-[#D1D1D1]">{bottomText}</p>}
        </div>

        {/* IMAGE FULL EDGE */}
        <div
          className={`relative z-20 overflow-hidden rounded-[10px]
  h-[300px] md:h-[400px] lg:h-[550px] xl:h-[550px]
  ${reverse ? 'lg:order-1' : 'lg:order-2'}`}
        >
          <img
            src={image}
            alt={title}
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};


